// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-204RXoAK","sider":"sider-1t34urNN","stock_box":"stock_box-35ip9KuN clearfix","sider_list":"sider_list-2RDLJ2pm"};